import { useTranslation } from 'react-i18next';
import { StudioIcon } from 'assets/icons';
import { ButtonContainer, DrawerEditButton } from './styled';

type PropTypes = {
  onClick: () => void;
};

const DrawerButton = ({ onClick }: PropTypes) => {
  const { t } = useTranslation();

  return (
    <ButtonContainer>
      <DrawerEditButton variant="extended" color="primary" onClick={onClick}>
        <StudioIcon />
        {t('aiMusicGenerator:editFormula')}
      </DrawerEditButton>
    </ButtonContainer>
  );
};

export default DrawerButton;
